type BrandMarkProps = { size?: number; className?: string };

export const BrandMark = ({ size = 32, className }: BrandMarkProps) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    aria-hidden="true"
    className={className}
  >
    <rect x={1.5} y={1.5} width={29} height={29} rx={9} fill="var(--primary)" />
    <path
      d="M16 24 V14.5"
      fill="none"
      stroke="var(--primary-ink)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16.5 C 16 12, 13.6 8.8, 9.4 8 C 8.7 12.2, 11.1 15.7, 16 16.5 Z"
      fill="var(--primary-ink)"
    />
    <path
      d="M16 14.5 C 16 10.6, 18.2 7.8, 22.1 7.2 C 22.7 11, 20.5 13.9, 16 14.5 Z"
      fill="var(--primary-ink)"
      opacity={0.82}
    />
  </svg>
);
